import { render, staticRenderFns } from "./common-swiper-banner.vue?vue&type=template&id=299508ca&scoped=true"
import script from "./common-swiper-banner.vue?vue&type=script&lang=js"
export * from "./common-swiper-banner.vue?vue&type=script&lang=js"
import style0 from "./common-swiper-banner.vue?vue&type=style&index=0&id=299508ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299508ca",
  null
  
)

export default component.exports